import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { McpPage } from "@/components/agents/mcp-page";

// Configuracion → Agentes (MCP): tokens para agentes de IA
// (docs/analisis-mcp-empresa.md). Mismo criterio de carpeta que `integrations/`.
export const Route = createFileRoute("/_authenticated/settings/_layout/agents/")({
  component: AgentsSettingsPage,
});

function AgentsSettingsPage() {
  return (
    <RouteGuardPermissions permissions={[{ module: "mcp", actions: ["read"] }]}>
      <McpPage />
    </RouteGuardPermissions>
  );
}
